import { AuraHeaderBar } from "@/components/aura/AuraHeaderBar";
import { AuraUpdatedAnswersPanel } from "@/components/aura/AuraUpdatedAnswersPanel";
import { AuraMetaSummary } from "@/components/aura/AuraMetaSummary";
import { AuraCoreColorsPalette } from "@/components/aura/AuraCoreColorsPalette";
import { AuraAuditResults } from "@/components/aura/AuraAuditResults";
import { AuraStackCompatibility } from "@/components/aura/AuraStackCompatibility";

export default function AuraPreview() {
  const limits = { maxSeconds: 15, maxRes: '1080p' as const, maxSizeMB: 250 };

  return (
    <div className="bg-neutral-50 text-slate-800 antialiased min-h-screen">
      <AuraHeaderBar />
      
      <main className="max-w-4xl mx-auto px-5 pb-24">
        <AuraUpdatedAnswersPanel limits={limits} />
        
        <section className="pt-8">
          <h1 className="text-3xl md:text-4xl tracking-tight font-semibold text-slate-900">
            Improved Design Mockups
          </h1>
          <p className="mt-2 text-[15px] text-slate-600">
            Mobile-first flow with calm visuals and quantified feedback. Key screens shown below.
          </p>
          <div className="mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500"></div>

          <AuraMetaSummary />
          <AuraCoreColorsPalette />
          <AuraAuditResults />
          <AuraStackCompatibility />
        </section>
      </main>
    </div>
  );
}